// libs
import React, { useRef, useState } from 'react';
import cx from 'classnames';
import dayjs from 'dayjs';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { Svg12 } from '@swiggy-private/dls-web-icons/dist/web/generic/chevronDown';
// components
import Menu from '@/components/Menu';
import { Content } from './components/Content';
import Modal from '@/components/Modal';
import CustomRangeModal from './components/CustomRangeModal';
// helpers
import { getStartAndEndDates } from './helper';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './DateRangeSelector.module.scss';
// defs
import { DateRangeEnum } from '@/stores/defs/metrics';
export const DateRangeLabel = {
    [DateRangeEnum.LAST_WEEK]: 'Last Week',
    [DateRangeEnum.LAST_MONTH]: 'Last Month',
    [DateRangeEnum.CUSTOM_RANGE]: 'Set Date Range',
};
const options = [
    DateRangeLabel[DateRangeEnum.LAST_WEEK],
    DateRangeLabel[DateRangeEnum.LAST_MONTH],
    DateRangeLabel[DateRangeEnum.CUSTOM_RANGE],
];
const getDateRangeEnumType = (option) => {
    switch (option) {
        case DateRangeLabel[DateRangeEnum.LAST_WEEK]:
            return DateRangeEnum.LAST_WEEK;
        case DateRangeLabel[DateRangeEnum.LAST_MONTH]:
            return DateRangeEnum.LAST_MONTH;
        default:
            return DateRangeEnum.CUSTOM_RANGE;
    }
};
function DateRangeSelector(props) {
    const { classNames, onSelect, selectedRange } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const menuApiRef = useRef(null);
    const getLabel = () => {
        const getDate = (date) => dayjs(date).format('DD MMM, YYYY');
        switch (selectedRange.type) {
            case DateRangeEnum.LAST_WEEK:
            case DateRangeEnum.LAST_MONTH:
                return DateRangeLabel[selectedRange.type];
            case DateRangeEnum.CUSTOM_RANGE:
                return `${getDate(selectedRange.range.startTime)} to ${getDate(selectedRange.range.endTime)}`;
        }
    };
    const getVariant = () => {
        switch (selectedRange.type) {
            case DateRangeEnum.LAST_WEEK:
            case DateRangeEnum.LAST_MONTH:
                return DlsFontVariants.body_B1_Bold;
            default:
                return DlsFontVariants.body_B2_Bold;
        }
    };
    const getColor = () => {
        switch (selectedRange.type) {
            case DateRangeEnum.LAST_WEEK:
            case DateRangeEnum.LAST_MONTH:
                return DlsColorTokens.text_Low_Emphasis;
            default:
                return DlsColorTokens.text_High_Emphasis;
        }
    };
    const handleOptionClick = (option) => {
        if (option === DateRangeLabel[DateRangeEnum.CUSTOM_RANGE]) {
            toggleModal();
            return;
        }
        const { startDate, endDate } = getStartAndEndDates(getDateRangeEnumType(option));
        onSelect(startDate, endDate, getDateRangeEnumType(option));
        toggleMenu();
    };
    const handleDateRangeSelect = (start, end) => {
        onSelect(start, end, DateRangeEnum.CUSTOM_RANGE);
        toggleModal();
    };
    const toggleMenu = () => {
        if (menuApiRef.current) {
            menuApiRef.current.isOpen
                ? menuApiRef.current.close()
                : menuApiRef.current.open();
        }
    };
    const toggleModal = () => {
        setIsModalOpen((prev) => !prev);
    };
    return (React.createElement("div", { className: styles.container },
        React.createElement(Menu, { Content: Content, contentProps: {
                handleOptionClick,
                toggleMenu,
                options,
                contentClassName: classNames === null || classNames === void 0 ? void 0 : classNames.content,
                optionClassName: classNames === null || classNames === void 0 ? void 0 : classNames.option,
            }, placement: "bottom-start", autoUpdatePosition: true, ref: menuApiRef },
            React.createElement("div", { onClick: toggleMenu, className: cx(classNames === null || classNames === void 0 ? void 0 : classNames.trigger, styles.trigger) },
                React.createElement(Text, { className: styles.firstColumn, variant: getVariant(), color: getColor() }, getLabel()),
                React.createElement(GenericIcon, { Icon: Svg12 }))),
        React.createElement(Modal, { open: isModalOpen, setOpen: toggleModal, closeOnOutsideClick: true, closeOnEscape: true, Content: CustomRangeModal, contentProps: {
                handleClose: toggleModal,
                handleSelectRange: handleDateRangeSelect,
            } })));
}
export default DateRangeSelector;
